import AlphaServiceList from './AlphaServiceList';

export { type AlphaServiceListProps } from './AlphaServiceList';
export default AlphaServiceList;
